import { FormControl, TextInput, TextInputProps } from '@primer/react';
import { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';

export interface IMyTextInputProps extends TextInputProps {
    register?: any,
    errors?: any,
    validateMessage?: string,
    name?: string,
    required?: boolean,
    minLength?: number,
    maxLength?: number,
    ref?: any,
    onValueDelayChanged?: (value: any) => void
}
const MyTextInput = (props: IMyTextInputProps) => {
    const { register, errors, validateMessage, name, required, minLength, maxLength, ref, onValueDelayChanged, ...textInputProps } = props;
    const [tempValue, setTempValue] = useState<any>(props.value ?? props.defaultValue);
    const tempValueDelayed = useDebounce(tempValue, 300)[0];
    useEffect(() => {
        setTempValue(props.value)
    }, [props.value])
    useEffect(() => {
        if (props.onValueDelayChanged && tempValueDelayed !== (props.value ?? props.defaultValue)) {
            props.onValueDelayChanged(tempValueDelayed)
        }
    }, [tempValueDelayed])
    // useEffect(() => {
    //     if (props.onValueDelayChanged && tempValueDelayed !== (props.value ?? props.defaultValue)) {
    //         props.onValueDelayChanged(tempValueDelayed)
    //     }
    // }, [props, tempValueDelayed])

    return (
        <>
            {register && props.name &&
                <>
                    <TextInput
                        // size='small'
                        ref={props.ref}
                        {...register(props.name, {
                            required: {
                                value: props.required,
                                message: props.validateMessage ?? ""
                            },
                            minLength: {
                                value: props.minLength,
                                message: props.validateMessage ?? ""
                            },
                            maxLength: {
                                value: props.maxLength,
                                message: props.validateMessage ?? ""
                            },
                            pattern: {
                                value: props.pattern,
                                message: props.validateMessage ?? ""
                            }

                        })}
                        name={props.name}
                        {...textInputProps}
                        onChange={(e) => {
                            setTempValue(e.target.value)
                            if (props.onChange) {
                                props.onChange(e)
                            }
                        }}
                    />
                    {
                        errors && errors[props.name] &&
                        <FormControl.Validation id={props.name} variant="error">
                            <> {errors[props.name].message ?? ""}</>
                        </FormControl.Validation>
                    }
                </>
            }
            {(!register || !props.name) &&
                <TextInput
                    // size='small'
                    {...textInputProps}
                    value={tempValue}
                    onChange={(e) => {
                        setTempValue(e.target.value)
                        if (props.onChange) {
                            props.onChange(e)
                        }
                    }}
                />
            }
        </>
    );
};

export default MyTextInput;